/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAnalysisRunSampleType } from './InternalApiAnalysisRunSampleType';
import {
    InternalApiAnalysisRunSampleTypeFromJSON,
    InternalApiAnalysisRunSampleTypeFromJSONTyped,
    InternalApiAnalysisRunSampleTypeToJSON,
    InternalApiAnalysisRunSampleTypeToJSONTyped,
} from './InternalApiAnalysisRunSampleType';
import type { InternalApiAnalysisRunStatus } from './InternalApiAnalysisRunStatus';
import {
    InternalApiAnalysisRunStatusFromJSON,
    InternalApiAnalysisRunStatusFromJSONTyped,
    InternalApiAnalysisRunStatusToJSON,
    InternalApiAnalysisRunStatusToJSONTyped,
} from './InternalApiAnalysisRunStatus';

/**
 * 
 * @export
 * @interface InternalApiScreeningClearanceRulesAnalysisRun
 */
export interface InternalApiScreeningClearanceRulesAnalysisRun {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    analysisId: number;
    /**
     * 
     * @type {InternalApiAnalysisRunSampleType}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    sampleType: InternalApiAnalysisRunSampleType;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    sampleSize?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    skipFilteredAlerts?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    fromDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    toDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    runTime?: Date;
    /**
     * 
     * @type {InternalApiAnalysisRunStatus}
     * @memberof InternalApiScreeningClearanceRulesAnalysisRun
     */
    status?: InternalApiAnalysisRunStatus;
}



/**
 * Check if a given object implements the InternalApiScreeningClearanceRulesAnalysisRun interface.
 */
export function instanceOfInternalApiScreeningClearanceRulesAnalysisRun(value: object): value is InternalApiScreeningClearanceRulesAnalysisRun {
    if (!('analysisId' in value) || value['analysisId'] === undefined) return false;
    if (!('sampleType' in value) || value['sampleType'] === undefined) return false;
    return true;
}

export function InternalApiScreeningClearanceRulesAnalysisRunFromJSON(json: any): InternalApiScreeningClearanceRulesAnalysisRun {
    return InternalApiScreeningClearanceRulesAnalysisRunFromJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesAnalysisRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningClearanceRulesAnalysisRun {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'analysisId': json['analysisId'],
        'sampleType': InternalApiAnalysisRunSampleTypeFromJSON(json['sampleType']),
        'sampleSize': json['sampleSize'] == null ? undefined : json['sampleSize'],
        'note': json['note'] == null ? undefined : json['note'],
        'skipFilteredAlerts': json['skipFilteredAlerts'] == null ? undefined : json['skipFilteredAlerts'],
        'fromDate': json['fromDate'] == null ? undefined : (new Date(json['fromDate'])),
        'toDate': json['toDate'] == null ? undefined : (new Date(json['toDate'])),
        'runTime': json['runTime'] == null ? undefined : (new Date(json['runTime'])),
        'status': json['status'] == null ? undefined : InternalApiAnalysisRunStatusFromJSON(json['status']),
    };
}

export function InternalApiScreeningClearanceRulesAnalysisRunToJSON(json: any): InternalApiScreeningClearanceRulesAnalysisRun {
    return InternalApiScreeningClearanceRulesAnalysisRunToJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesAnalysisRunToJSONTyped(value?: InternalApiScreeningClearanceRulesAnalysisRun | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'analysisId': value['analysisId'],
        'sampleType': InternalApiAnalysisRunSampleTypeToJSON(value['sampleType']),
        'sampleSize': value['sampleSize'],
        'note': value['note'],
        'skipFilteredAlerts': value['skipFilteredAlerts'],
        'fromDate': value['fromDate'] == null ? value['fromDate'] : value['fromDate'].toISOString(),
        'toDate': value['toDate'] == null ? value['toDate'] : value['toDate'].toISOString(),
        'runTime': value['runTime'] == null ? value['runTime'] : value['runTime'].toISOString(),
        'status': InternalApiAnalysisRunStatusToJSON(value['status']),
    };
}

